var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-subheader',{staticClass:"px-0"},[_vm._t("default"),_c('v-divider',{staticClass:"ml-4"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }